import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, CORE_LOCATIONS, PUBLIC } from "../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${CORE_LOCATIONS}`;

// Accept optional "keyword" to search
export const fetchPublicCoreLocations = async (keyword = "") => {
  const params = new URLSearchParams();
  if (keyword && keyword.trim()) {
    params.set("keyword", keyword.trim());
  }
  const url = params.toString() ? `${API_BASE_URL}?${params.toString()}` : `${API_BASE_URL}`;

  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
    // keep existing behavior so the thunk handles error via rejectWithValue
  }
};